import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DateAndTimeComponent } from '@features-shared/date-and-time/date-and-time.component';
import { TranslateModule } from '@ngx-translate/core';
import { UserDateInfo } from '@shared/types';
import { FormLabelComponent } from '@ui-kit/form';
import { EllipsisTooltipComponent } from '@ui-kit/miscs';

@Component({
    selector: 'user-date',
    standalone: true,
    imports: [EllipsisTooltipComponent, TranslateModule, FormLabelComponent, DateAndTimeComponent],
    templateUrl: './user-date.component.html',
    styleUrl: './user-date.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDateComponent {
    userData = input.required<UserDateInfo | null>();

    isCentered = input<boolean>(false);
    label = input<string | null>(null);
    inline = input<boolean>(false);
    dateOnly = input<boolean>(false);
    minWidth = input<string>('unset');
    showTime = input<boolean>(false);
    disableTooltip = input<boolean>(true);
}
